import { ApiResponse } from 'apisauce';
import { eventsNetwork, network } from './network';

const basePath = (semesterId: number) => `/semesters/${semesterId}/ics`;

export interface IcsApi {
  checkForIcsUpdates: (
    semesterId: number,
    defaultDaysAhead: number,
    forceCheck?: boolean
  ) => Promise<ApiResponse<{ [key: string]: any[] }>>;
  parseIcsFeed: (
    semesterId: number,
    data: { url: string; timezone: string }
  ) => Promise<ApiResponse<{ [key: string]: any[] }>>;
  unsyncCourseFromLMS: (semesterId: number, courseId: number, platform?: string) => Promise<ApiResponse<any>>;
}

// NOTE: This hits event-service only - watch out NOT to use basePath
export const parseIcsFeed = (semesterId: number, data: { url: string; timezone: string }) =>
  eventsNetwork.get<{ [key: string]: any[] }>(`/ics/${semesterId}/parse`, data);

export const checkForIcsUpdates = (semesterId: number, defaultDaysAhead: number, forceCheck?: boolean) =>
  network.get<{ [key: string]: any[] }>(`${basePath(semesterId)}/check-updates`, {
    defaultDaysAhead,
    force: forceCheck ?? false
  });

export const unsyncCourseFromLMS = (semesterId: number, courseId: number, platform?: string) =>
  network.delete<any>(`semesters/${semesterId}/courses/${courseId}/unsync-lms`, platform ? { platform } : {});

export const icsApi: IcsApi = {
  checkForIcsUpdates,
  parseIcsFeed,
  unsyncCourseFromLMS
};
